import dynamic from "next/dynamic";

import SVG from "react-inlinesvg";

const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import IPLSponsor from "@/component/IPL/IPLSponser";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { parseMatchData } from "@/utils/ipl";
import { logger } from "@/utils/logging/log-util";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));

const MatchListPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
  matchData = null,
  currentTab = 1,
}) => {
  const [readMore, setReadMore] = useState(true);
  const [matchList, setMatchList] = useState(matchData);
  const dateFilterMatches =
    matchList &&
    matchList?.reduce((group, match) => {
      const { match_date_alt } = match;
      if (match_date_alt != "Invalid Date") {
        if (!group[match_date_alt]) {
          group[match_date_alt] = [];
        }
        group[match_date_alt].push(match);
        return group;
      } else {
        const dt = new Date().toLocaleDateString("en-US", {
          day: "2-digit",
          weekday: "short",
          month: "short",
        });
        if (!group[dt]) {
          group[dt] = [];
        }
        group[dt].push(match);
        return group;
      }
    }, {});

  const filteredMatchData =
    currentTab == 2
      ? Object.entries(dateFilterMatches || []).reverse()
      : Object.entries(dateFilterMatches || []);
  // ads implement
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  useEffect(() => {
    if (matchData && matchData[0]?.status == "LIVE") {
      async function getMatches() {
        try {
          const timeStamp = Date.now();
          // const matches = await getDataFromSSR(
          //   `/api/getLiveMatches?time=${timeStamp}`
          // );
          const matches = null; //disable getLiveMatches
          setMatchList((prevMatches) => {
            const updated = [...prevMatches];

            for (const rawMatch of matches.data.data) {
              const matchStats = parseMatchData(rawMatch);
              const idx = updated.findIndex((m) => m.id === rawMatch.match_Id);

              if (idx > -1) {
                updated[idx] = matchStats; // update existing
              } else {
                updated.unshift(matchStats); // prepend new
              }
            }
            return updated;
          });
          // if (matches && matches.data?.data?.length > 0) {
          //   const matchStats = parseMatchData(matches.data?.data[0]);
          //   setLiveMatch(matchStats);
          // }
        } catch (err) {
          logger.error(err);
        }
      }

      getMatches();
      const interval = setInterval(() => {
        getMatches();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);

  const title =
    currentTab == 1
      ? "IPL 2025 Live Score Today: Latest IPL Matches & Scorecard - NewsTak"
      : currentTab == 2
        ? "IPL 2025 Upcoming Matches: Fixtures, Dates & Timings – NewsTak"
        : "IPL 2025 Recent Matches: Latest Scores & Match Results - NewsTak";
  const description =
    currentTab == 1
      ? "IPL 2025 Live Score Today: Get real-time live scores, ball-by-ball updates, scorecards & Live Score of all matches in one place."
      : currentTab == 2
        ? "Check the list of upcoming IPL 2025 matches with team-wise fixtures, match dates, venues, and start times. Stay updated with what’s next in IPL 2025."
        : "Get all the latest IPL 2025 match results, scores, and highlights. Stay updated with team performances, key moments, and post-match summaries.";
  const keywords =
    currentTab == 1
      ? "IPL Live Score 2025, IPL 2025 Live Match, Live Cricket Score IPL, Today IPL Match Live Score, IPL Match Scorecard"
      : currentTab == 2
        ? "IPL 2025 Upcoming Matches, IPL 2025 Next Match, IPL 2025 Fixtures, IPL Match Schedule 2025, IPL 2025 Match Dates, Today IPL Match, IPL 2025 Match Timings, IPL Upcoming Match List"
        : "IPL 2025 Recent Matches, IPL 2025 Match Results, Latest IPL Scores 2025, IPL 2025 Today Match Result, IPL Live Score Updates 2025, IPL 2025 Highlights, Who won today’s IPL match, IPL 2025 Match Recap";
  const canonical = router?.asPath;

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    ...(currentTab == 1
      ? [
        {
          id: "3",
          title: "Live Matches",
          canonical_url: "/sports/ipl/live",
          amp_url: "",
        },
      ]
      : []),
    ...(currentTab == 2
      ? [
        {
          id: "3",
          title: "Upcoming Matches",
          canonical_url: "/sports/ipl/upcoming",
          amp_url: "",
        },
      ]
      : []),
    ...(currentTab == 3
      ? [
        {
          id: "3",
          title: "Recent Matches",
          canonical_url: "/sports/ipl/recent",
          amp_url: "",
        },
      ]
      : []),
  ];
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />

      <section className="px-4 py-2">
        <h1 className="my-4 font-semibold text-lg">
          {currentTab == 1
            ? "IPL 2025 Live Score Today"
            : currentTab == 2
              ? "IPL 2025 Upcoming Matches"
              : "IPL 2025 Recent Matches"}
        </h1>
        <p className={`text-[#323232] text-sm text-left relative inline`}>
          <span className={`${readMore ? "line-clamp-2" : ""}`}>
            22 मार्च से IPL की शुरुआत हुई थी और इसका फाइनल 25 मई को ईडन गार्डन,
            कोलकाता में खेला जाएगा. IPL में इस वर्ष कुल 74 मैच राउंड रॉबिन
            फॉर्मेट में खेले जाएंगे. जिसके बाद टॉप चार टीमों के बीच सेमीफाइनल व
            फाइनल खेला जाएगा. टूर्नामेंट की 10 टीमों के 2 ग्रुप बनाए गए हैं. इस
            तरह की अन्य जानकारियां जैसे कब कौन सा मैच है, कहां होगा किस समय
            होगा. तमाम जानकारियों के लिए हमारे साथ जुड़े.
          </span>
          <span
            onClick={() => {
              setReadMore((prev) => !prev);
            }}
            className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
          >
            {readMore ? "और देखें >" : "< कम देखें"}
          </span>
        </p>

        {/* navbar  */}
        <div className="w-full flex items-center justify-start p-2">
          <div
            className={`w-[35%] text-center text-md  ${currentTab == 1
              ? "border-b-2 border-primary text-primary"
              : "text-[#00000099] border-b border-gray-200"
              }`}
          >
            <a href={"/sports/ipl/live"} target="_self">
              Live
            </a>
          </div>
          <div
            className={`w-[35%] text-center text-md  ${currentTab == 2
              ? "border-b-2 border-primary text-primary"
              : "text-[#00000099] border-b border-gray-200"
              }`}
          >
            <a href={"/sports/ipl/upcoming"} target="_self">
              Upcoming
            </a>
          </div>
          <div
            className={`w-[35%] text-center text-md  ${currentTab == 3
              ? "border-b-2 border-primary text-primary"
              : "text-[#00000099] border-b border-gray-200"
              }`}
          >
            <a href={"/sports/ipl/recent"} target="_self">
              Recent
            </a>
          </div>
        </div>
        {!filteredMatchData?.length && (
          <div className="w-full flex flex-col justify-center items-center mt-12 mb-16 py-4 text-gray-500">
            <SVG
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/NoMatchData.svg"
              className="w-22 h-22 rounded-full mb-4"
            />
            No Matches Found
          </div>
        )}
        {scrolled && currentTab == 1 && (
          <>
            <AdSlot300x250
              divId={"div-gpt-ad-1659434604998-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-2"}
              minWidth="720px"
              minHeight="90px"
            />
          </>
        )}
        {filteredMatchData?.length > 0 &&
          filteredMatchData.map(([matchDate, matches], idx) => {
            return (
              <div key={matchDate} className="w-full">
                {idx == 1 && scrolled && currentTab != 1 && (
                  <>
                    <AdSlot300x250
                      divId={"div-gpt-ad-1659434604998-0"}
                      minWidth="300px"
                      minHeight="250px"
                    />

                    <AdSlot728x90
                      divId={"div-gpt-ad-1707804176041-2"}
                      minWidth="720px"
                      minHeight="90px"
                    />
                  </>
                )}

                <h2 className="bg-[#CDCDCD] w-fit p-2 rounded-full my-4 text-sm mx-auto">
                  {matchDate}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2">
                  {matches
                    ?.sort((a, b) => a.match_time.localeCompare(b.match_time))
                    .map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="min-w-full md:min-w-[50%] bg-white rounded-lg border border-gray-300 py-2"
                        >
                          <a
                            href={
                              item?.teamA_name == "tbc"
                                ? ""
                                : item?.url || "/sports/ipl"
                            }
                            onClick={(e) => {
                              if (item?.teamA_name === "tbc") {
                                e.preventDefault(); // Prevent default link behavior
                              }
                            }}
                          >
                            <div className="w-full px-2 border-b border-gray-400 flex items-center justify-between">
                              <span className="text-[#000000CC] flex items-center gap-1 text-sm mb-1">
                                <span className="font-semibold">
                                  {"IPL 2025"}
                                </span>
                                <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                                {item?.match_no}
                              </span>
                              <span className="flex items-center gap-1 text-sm mb-1">
                                {item.status}
                                {item?.status == "LIVE" && (
                                  <img
                                    height={24}
                                    width={24}
                                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveGif.gif"
                                    alt="live icon"
                                  />
                                )}
                              </span>
                            </div>
                            <div className="p-2">
                              <span className="flex items-center gap-2 mb-2">
                                <img
                                  width={24}
                                  height={24}
                                  src={
                                    item.teamA_name != "tbc"
                                      ? ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${item?.teamA_name}1.png`
                                      : item.teama_logo
                                  }
                                  alt="teamA logo"
                                // className="rounded-full"
                                />
                                <span className="flex items-cetner gap-1 text-xs font-[600]">
                                  {item?.teamA_name?.toUpperCase()}
                                  {item?.winning_team == "A" &&
                                    !item?.equation?.includes(
                                      "Match Postponed"
                                    ) &&
                                    !item?.equation?.includes(
                                      "Match Abandoned"
                                    ) && (
                                      <img
                                        src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                                        width={20}
                                        height={20}
                                        alt="trophy gif"
                                        className="-mt-1"
                                      />
                                    )}
                                </span>
                                {item?.status == "UPCOMING" ? (
                                  <span className={`text-sm ml-auto `}>
                                    {item.match_date}
                                  </span>
                                ) : (
                                  <span
                                    className={`text-sm ml-auto ${item?.batting_team == "A" ||
                                      item?.winning_team == "A"
                                      ? "font-semibold"
                                      : "mr-1"
                                      }`}
                                  >
                                    {item.teamA_score || "Yet to bat"}{" "}
                                    {item.teamA_overs
                                      ? "(" + item.teamA_overs + ")"
                                      : ""}
                                    {item?.batting_team == "A" && (
                                      <span className="text-primary text-md font-semibold">
                                        *
                                      </span>
                                    )}
                                  </span>
                                )}
                              </span>
                              <span className="flex items-center gap-2 mb-1">
                                <img
                                  width={24}
                                  height={24}
                                  src={
                                    item.teamB_name != "tbc"
                                      ? ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${item?.teamB_name}1.png`
                                      : item.teamb_logo
                                  }
                                  alt="teamA logo"
                                // className="rounded-full"
                                />
                                <span className="flex items-center gap-1 text-xs font-[600]">
                                  {item?.teamB_name?.toUpperCase()}
                                  {item?.winning_team == "B" &&
                                    !item?.equation?.includes(
                                      "Match Postponed"
                                    ) &&
                                    !item?.equation?.includes(
                                      "Match Abandoned"
                                    ) && (
                                      <img
                                        src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                                        width={20}
                                        height={20}
                                        alt="trophy gif"
                                        className="-mt-1"
                                      />
                                    )}
                                </span>
                                {item?.status == "UPCOMING" ? (
                                  <span className={`text-sm ml-auto `}>
                                    {item.match_time}
                                  </span>
                                ) : (
                                  <span
                                    className={`text-sm ml-auto ${item?.batting_team == "B" ||
                                      item?.winning_team == "B"
                                      ? "font-semibold"
                                      : "mr-1"
                                      }`}
                                  >
                                    {item.teamB_score || "Yet to bat"}{" "}
                                    {item.teamB_overs
                                      ? "(" + item.teamB_overs + ")"
                                      : ""}
                                    {item?.batting_team == "B" && (
                                      <span className="text-primary text-md font-semibold">
                                        *
                                      </span>
                                    )}
                                  </span>
                                )}
                              </span>
                            </div>
                            <div className="bg-gray-200 w-full p-2 text-center text-xs font-semibold">
                              <span>{item?.equation}</span>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={true}
          scrolled={scrolled}
        />
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </section>
    </div>
  );
};

export default MatchListPage;
